import React from "react";
import { Grid, Button, IconButton, Link } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useSelector } from "react-redux";

function Footer() {
  const { data: user } = useSelector((state) => state.user);

  return (
    <Grid container spacing={2} className="footer-box">
      <Grid item xs={12} sm={6} className="footer-text">
        NetSuite Backup Solution by <Link className='footer-color' href='https://vastedge.com/' target='_blank'>&nbsp;Vast Edge&nbsp;</Link> - Release 1.0
      </Grid>
      <Grid item xs={12} sm={6} className="footer-text" style={{ display: "flex", justifyContent: "flex-end" }}>
        Powered by&nbsp;<Button className='footer-link footer-color' onClick={() => window.open('https://vastedge.com/?ref=quorum&id=' + `${user.id}`, '_blank')}>Vast Edge</Button>

&nbsp;&nbsp;|<Button title="Print" onClick={() => window.print()}>
          <PrintIcon style={{ marginRight: "40px", marginTop:"-10px" }} />
        </Button>
      </Grid>
    </Grid>
  );
}

export default Footer;
